export const CONFERMATO = 3;
export const RICHIESTO = 1;
export const RILASCIATO = 2;